import {Point} from '@colonist/game-mechanic-validators'
import {ViewAnimationController} from '../ViewAnimationController'
import {UIGameGoToPointAnimation} from './UIGameGoToPointAnimation'
import {PIXI} from '@colonist/pixi'

export class ViewAnimationControllerAdapter extends ViewAnimationController {
    private readonly animation: UIGameGoToPointAnimation

    constructor(view: PIXI.Container) {
        super(view)
        this.animation = new UIGameGoToPointAnimation(view, new Point(0, 0), 0)
    }

    override set animationCompleteCallBack(value: () => void) {
        this.animation.setOnStopCallback(value)
    }

    /** @deprecated If you see this, refactor the animation to use GoToPointAnimation instead` */
    animateTo(destination: Point, speed?: number): void {
        this.animation?.setSpeed(speed ?? 1).setDestination(destination).start()
    }
}
